import axios from "axios";
import { getAuth } from "firebase/auth";

// const API_BASE_URL = "http://localhost:2000"; // Change this if deployed
const API_BASE_URL = process.env.REACT_APP_API_URL; // Change this if deployed

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

axiosInstance.interceptors.request.use(
  async (config) => {
    const user = getAuth().currentUser;

    if (user) {
      const token = await user.getIdToken();
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default axiosInstance;
